import { raise, values } from '@weft/utils';
import type { PlanCreateReason } from '../../../../contexts/create-plan-context/create-plan-context-types/plan-create-reason';
import { PLAN_CREATION_REASONS } from '../../../../contexts/create-plan-context/create-plan-context-types/plan-create-reason';
import { useStateParams } from '../../../../hooks/use-state-params';

export function useContractRevisePagePlanCreateReasonParam() {
  return useStateParams<PlanCreateReason>(PLAN_CREATION_REASONS.ReviseCurrentContract, 'planCreateReason', String, deserializePlanCreateReasonParam);
}

function deserializePlanCreateReasonParam(paramString: string): PlanCreateReason | null {
  if (values<string>(PLAN_CREATION_REASONS).includes(paramString)) {
    return paramString as PlanCreateReason;
  }

  return raise(`Invalid plan create reason param: ${paramString}`);
}